import { useState } from "react";
import { Form } from "antd";
import TableModal from "./table-modal";
import CreateProductModal from "./create-product-modal";
import UpdateProductModal from "./update-product-modal";
import UploadModal from "./upload-modal";

const ProductModal = ({
  onClose,
  fieldName,
  form,
  isReturned,
  setDeliveryType,
  setDesi,
}) => {
  const [productForm] = Form.useForm();
  const [step, setStep] = useState("TABLE");
  const [spin, setSpin] = useState(false);
  const [updateValues, setUpdateValues] = useState(null);

  return (
    <>
      {step === "TABLE" && (
        <TableModal
          onClose={onClose}
          fieldName={fieldName}
          form={form}
          setStep={setStep}
          setUpdateValues={setUpdateValues}
          isReturned={isReturned}
          setDeliveryType={setDeliveryType}
          setDesi={setDesi}
        />
      )}
      {step === "FORM" && (
        <CreateProductModal
          form={productForm}
          onClose={onClose}
          setStep={setStep}
          setSpin={setSpin}
          spin={spin}
        />
      )}
      {step === "UPDATE" && (
        <UpdateProductModal
          form={productForm}
          onClose={onClose}
          setStep={setStep}
          setSpin={setSpin}
          spin={spin}
          updateValues={updateValues}
          deliveryForm={form}
          fieldName={fieldName}
          isReturned={isReturned}
          setDeliveryType={setDeliveryType}
          setDesi={setDesi}
        />
      )}
      {step === "UPLOAD" && (
        <UploadModal
          form={productForm}
          onClose={onClose}
          setStep={setStep}
          setSpin={setSpin}
          spin={spin}
        />
      )}
    </>
  );
};
export default ProductModal;
